$(document).ready(() => {
	
	const $newsletterForm = $('#newsletter-form');
	
	if($newsletterForm.length) {
		
		$newsletterForm.submit(function(e){
			e.preventDefault();

			const form = $( this ),
						url = form.attr( "action" );

			var posting = $.post( url, form.serialize() );

			posting.done(function( data ) {
				$('#newsletter-form').fadeOut(400, function () {
					$('#newsletter-message').find('.message-box .message').html(data.msg);
					$('#newsletter-message').fadeIn(1000);
				});
			});
		});

	}
});


// WEBPACK FOOTER //
// ./public/javascripts/modules/newsletterForm.js